import React, { useState, useEffect, useRef, useMemo } from 'react';
import { useParams, useNavigate  } from 'react-router-dom';
import JoditEditor from "jodit-react";
import { ServerUrl } from '../../../../../api/ServerUrl';
import { ProtectAPi } from '../../../../../api/ProtectAPi';
import swal from 'sweetalert';
import BackButton from '../../../../tools/BackButton';

const BlogEdit = () => {
    const { http } = ProtectAPi();
    const navigate = useNavigate();
    const editor = useRef(null);
    const { id } = useParams();
    const [loader, setLoader] = useState('off');
    const [layoutTitle, setLayoutTitle] = useState('');
    const [layoutSlug, setLayoutSlug] = useState('');
    const [layoutDescription, setLayoutDescription] = useState('');
    const [layoutImage, setLayoutImage] = useState(null);
    const [layoutImageAlt, setLayoutImageAlt] = useState('');
    const [layoutImageError, setLayoutImageError] = useState('');
    const [imagePreview, setImagePreview] = useState('');
    const [titleError, setTitleError] = useState('');
    const [descriptionError, setDescriptionError] = useState('');
    const httpCPage = ServerUrl;

    useEffect(() => {
        http.get(`/get-single-blog/${id}`)
            .then(res => {
                setLayoutTitle(res.data.title);
                setLayoutSlug(res.data.slug || '');
                setLayoutDescription(res.data.description);
                setLayoutImageAlt(res.data.alt_text || '');
                const layoutImage = res.data.image;
                if (layoutImage) {
                    const layoutImageShow = `${httpCPage}/backend/img/blog/${layoutImage}`;
                    setImagePreview(layoutImageShow);
                }
            })
            .catch(error => {
                console.error('Error fetching blog:', error);
            });
    }, [id]);

    const submitForm = () => {
        setLoader('on');
        setLayoutImageError('');
        setTitleError('');
        setDescriptionError('');
        const formData = new FormData();
        formData.append('title', layoutTitle);
        formData.append('slug', layoutSlug);
        formData.append('description', layoutDescription);
        formData.append('image', layoutImage);
        formData.append('alt_text', layoutImageAlt);

        http.post(`/update-blog/${id}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        }).then(res => {
            if (res.data.status === '422') {
                const errors = res.data.error;
                setLoader('off');
                setLayoutImageError(errors.image ? errors.image[0] : '');
                setTitleError(errors.title ? errors.title[0] : '');
                setDescriptionError(errors.description ? errors.description[0] : '');
            } else {
               setLoader('off');
                swal('Success', res.data.msg, 'success').then(() => {
                    navigate('/admin/pages/home/blog-list'); 
                });
            }
        }).catch(error => {
            console.error('Error:', error);
        });
    };

    const handleImageChange = (e) => {
        const selectedImage = e.target.files[0];
        setLayoutImage(selectedImage);
        const previewURL = URL.createObjectURL(selectedImage);
        setImagePreview(previewURL);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (name === 'layoutTitle') setLayoutTitle(value);
        if (name === 'layoutSlug') setLayoutSlug(value);
        if (name === 'layoutImageAlt') setLayoutImageAlt(value);
    };

    const placeholder = 'Start typing...';
    const editorConfig = useMemo(
        () => ({
            readonly: false,
            placeholder: placeholder,
            uploader: {
                insertImageAsBase64URI: true
            }
        }),
        [placeholder]
    );

    return (
        <div>
            <div className="main-content">
                <section className="section">
                    <div className="section-body">
                        <div className="row">
                            <div className="col-12">
                                <div className="card card-primary">
                                    <div className="card-body">
                                        <div className="d-flex justify-content-between">
                                            <h5>Edit Blog</h5>
                                            <BackButton />
                                        </div>
                                        <div className="card-body pb-0">
                                            <div className="row">
                                                <div className="col-md-6 mt-4">
                                                    <label>Blog Image</label>
                                                    <div className="logo-box">
                                                        <div className="logo">
                                                            <label htmlFor="layoutImage">
                                                                <div className="image-box border dottet p-2 rounded">
                                                                    {imagePreview ? (
                                                                        <img src={imagePreview} className='img-fluid' alt="Preview" />
                                                                    ) : (
                                                                        <img src="https://w7.pngwing.com/pngs/159/705/png-transparent-computer-computer-trademark-computer-logo.png" className='img-fluid' alt="Default" />
                                                                    )}
                                                                </div>
                                                                <input type="file" id="layoutImage" className="form-control d-none" onChange={handleImageChange} />
                                                                <span className='btn btn-primary mt-1 w-100'>Upload Blog Image</span>
                                                                <span className='text-danger'>{layoutImageError}</span>
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-md-12 mt-4">
                                                    <div className="form-group">
                                                        <label>Alt Text for Image</label>
                                                        <input type="text" name="layoutImageAlt" value={layoutImageAlt} onChange={handleInputChange} className="form-control" placeholder="Enter image alt text" />
                                                    </div>
                                                </div>

                                                <div className="col-md-12 mt-2">
                                                    <div className="form-group">
                                                        <label>Title</label>
                                                        <input type="text" name="layoutTitle" value={layoutTitle} onChange={handleInputChange} className="form-control" placeholder="Title" />
                                                        <span className='text-danger'>{titleError}</span>
                                                    </div>
                                                </div>

                                                <div className="col-md-12 mt-2">
                                                    <div className="form-group">
                                                        <label>Slug (optional)</label>
                                                        <input type="text" name="layoutSlug" value={layoutSlug} onChange={handleInputChange} className="form-control" placeholder="Enter custom slug (optional)" />
                                                    </div>
                                                </div>

                                                <div className="col-md-12 mt-4">
                                                    <label>Description</label>
                                                    <JoditEditor
                                                        ref={editor}
                                                        value={layoutDescription}
                                                        config={editorConfig}
                                                        tabIndex={1}
                                                        onBlur={newContent => setLayoutDescription(newContent)}
                                                        onChange={() => {}}
                                                    />
                                                    <span className='text-danger'>{descriptionError}</span>
                                                </div>

                                                <div className="col-md-12 mt-5 mb-4">
                                                    {loader === 'off' ?
                                                        <button type="submit" onClick={submitForm} className="btn btn-primary btn-lg">Update</button> :
                                                        <div className="spinner-border text-dark" role="status"></div>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
};

export default BlogEdit;
